import HeaderStrip from "../../../components/header-strip/HeaderStrip";
import home from '../../../assets/images/dashboard/home.png';
import girl from '../../../assets/images/dashboard/girl.png';
import admin from '../../../assets/images/dashboard/admin.svg';
import parentOrganisation from '../../../assets/icons/dashboard/parent-organisation.svg';
import childOrganisation from '../../../assets/icons/dashboard/child-organisation.svg';
import linkedOrganisation from '../../../assets/icons/dashboard/linked-organisation.svg';
import './_choose-entity.scss';
import { Col, Input, Result, Row } from "antd";
import { toTitleCase } from "../../../utils/helper";
import PrimaryButton from "../../../components/UI/Button/Button";
import { useDispatch, useSelector } from "react-redux";
// import { ChooseEntitySkeleton } from "./ChooseEntitySkeleton";
import { multiEntityActions, Organisation } from "../../../store/multiEntity";
import React, { useEffect, useState } from "react";
import searchIcon from '../../../assets/icons/search.svg'
import LoadingComponent from "../../../components/UI/Loading/LoadingComponent";


const ChooseEntity: React.FC = () => {
  const { entities, totalAdminCount } = useSelector((state: any) => state.multiEntity);
  const [loading, setLoading] = useState(false);
  const [filteredEntities, setFilteredEntities] = useState<Organisation[]>([]);
  const dispatch = useDispatch();
  const organisationTypeIconMap = new Map([
    ['PARENT', parentOrganisation],
    ['CHILD', childOrganisation],
    ['LINKED', linkedOrganisation]
  ]);
  const statCards = [
    {
      title: 'Total Lives',
      value: entities?.reduce((acc: number, curr: Organisation) => acc + curr.lives_covered, 0),
      image: home,
      bgClass: 'bg-right'
    },
    {
      title: 'Total Employees',
      value: entities?.reduce((acc: number, curr: Organisation) => acc + curr.employee_count, 0),
      image: girl,
      bgClass: 'bg-left'
    },
    {
      title: 'Total Admins',
      value: totalAdminCount,
      image: admin,
      bgClass: 'bg-left'
    }
  ];
  const handleChooseEntity = (organisation_uuid: string) => {
    dispatch(multiEntityActions.setChosenEntity(entities.find((entity: Organisation) => entity.organisation_uuid === organisation_uuid)));
  };

  useEffect(() => {
    if (entities?.length > 0) {
      setFilteredEntities(entities);
      setLoading(false);
    } else {
      setLoading(true);
    }
  }, [entities]);

  return (
    <React.Fragment>
      <HeaderStrip canSwitchToEmployee={true} />
      <LoadingComponent loading={loading}>
        <div className="entity-choosing">
          <div className="select-organisation">Select Organisation</div>
          <div className="select-organisation-description">Choose an organization to access its dashboard and manage operations</div>
          <Row justify="center" gutter={16} align="middle" className="stats-card-container">
            {statCards.map((card, index) => (
              <Col key={index}>
                <div className="stats-card">
                  <Row gutter={16} align="middle">
                    <Col className={`icon-container ${card.bgClass}`}>
                      <img src={card.image} className="icon-image" alt={card.title} />
                    </Col>
                    <Col className="stats-card-content">
                      <div className="title">{card.title}</div>
                      <div className="value">{card.value}</div>
                    </Col>
                  </Row>
                </div>
              </Col>
            ))}
          </Row>

          <div className="organisation-list">
            {entities.length > 3 && <Row justify="space-between" align="middle">
              <Col>
                <div className="title">Organisations</div>
                <div className="subtitle">{filteredEntities.length} organisations found</div>
              </Col>
              <Col>
                <Input
                  className="search-input"
                  allowClear
                  placeholder="Search by name"
                  prefix={<img src={searchIcon} alt="search" />}

                  style={{ width: '322px' }}
                  onChange={(e) => {
                    if (!e.target.value || e.target.value === '') {
                      setFilteredEntities(entities);
                    } else {
                      setFilteredEntities(entities?.filter((entity: Organisation) => entity.organisation_name.toLowerCase().includes(e.target.value.toLowerCase())));
                    }
                  }}
                />
              </Col>
            </Row>}
            {filteredEntities?.length > 0 && <Row align="middle" gutter={[24, 24]} style={{ marginTop: '24px' }} justify={filteredEntities?.length > 3 ? "start" : "center"}>
              {filteredEntities?.map((organisation: Organisation, index: number) => (
                <Col span={6} key={index}>
                  <div className="organisation-list-item">
                    <Row className="header" justify="space-between" align="middle">
                      <Col>
                        <div className="icon">
                          <img src={organisationTypeIconMap.get(organisation.corporate_type)} alt={organisation.corporate_type} />
                        </div>
                      </Col>
                      <Col>
                        <div className={`type ${organisation.corporate_type.toLowerCase()}`}>
                          {toTitleCase(organisation.corporate_type)} Organisation
                        </div>
                      </Col>
                    </Row>
                    <div className="name">{organisation.organisation_name}</div>
                    <Row gutter={24} justify="space-between" align="middle" className="stats">
                      <Col span={8}>
                        <div className="stat-card">
                          <div className="label">Lives</div>
                          <div className="value">{organisation.lives_covered}</div>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div className="stat-card">
                          <div className="label">Employees</div>
                          <div className="value">{organisation.employee_count}</div>
                        </div>
                      </Col>
                      <Col span={8}>
                        <div className="stat-card">
                          <div className="label">Admins</div>
                          <div className="value">{organisation.employer_count}</div>
                        </div>
                      </Col>
                    </Row>
                    <PrimaryButton block onClick={() => handleChooseEntity(organisation?.organisation_uuid)}>ACCESS DASHBOARD</PrimaryButton>
                  </div>
                </Col>
              ))}
            </Row>}
            {filteredEntities.length === 0 && <Result status="404" title="No Organisations Found" subTitle="Please try searching something else." />}
          </div>
        </div>
      </LoadingComponent>
    </React.Fragment>
  );
};

export default ChooseEntity;
